import { render, staticRenderFns } from "./monitoringPoints.vue?vue&type=template&id=79cc4a0e&"
import script from "./monitoringPoints.vue?vue&type=script&lang=js&"
export * from "./monitoringPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports